import { User } from "./user.model";

export class FcmMessage {
    type: string;
    data: any;
    user: User;
}


// WEBPACK FOOTER //
// C:/Azure/Source/Workspaces/SalesNOW/SalesSOLO/WebSites/SalesSOLO.Web.Angular.telesales/src/app/models/fcmMessage.model.ts